import React from "react";
import { MessageCircle } from "lucide-react";

// Owner WhatsApp: +1 305 699 4889 (Florida)
const WHATSAPP_URL = "https://wa.me/13056994889?text=Hola%20MedBridge%2C%20quiero%20saber%20m%C3%A1s";

export default function FloatingWhatsApp() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-20 right-4 md:bottom-6 md:right-6 z-50 group"
      data-testid="floating-whatsapp"
      aria-label="Contactar por WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 group-hover:opacity-60 animate-ping" />
      <span className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] shadow-[0_10px_30px_-5px_rgba(37,211,102,0.55)] text-white transition-transform duration-200 group-hover:scale-110">
        <svg
          viewBox="0 0 24 24"
          className="w-7 h-7 md:w-8 md:h-8"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M20.52 3.48A11.77 11.77 0 0 0 12.04 0C5.5 0 .18 5.32.18 11.87c0 2.09.55 4.13 1.6 5.93L0 24l6.38-1.67a11.85 11.85 0 0 0 5.66 1.44h.01c6.54 0 11.86-5.32 11.86-11.87 0-3.17-1.24-6.15-3.39-8.42zM12.05 21.8h-.01a9.9 9.9 0 0 1-5.04-1.38l-.36-.21-3.78.99 1-3.68-.23-.38a9.9 9.9 0 0 1-1.52-5.27c0-5.47 4.45-9.92 9.93-9.92 2.65 0 5.14 1.03 7.01 2.91a9.86 9.86 0 0 1 2.9 7.01c0 5.47-4.45 9.93-9.9 9.93zm5.44-7.43c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15s-.77.97-.95 1.17c-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.39-1.47-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01a1.1 1.1 0 0 0-.8.37c-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.06 2.88 1.21 3.08.15.2 2.09 3.2 5.07 4.49.71.31 1.26.49 1.69.63.71.22 1.35.19 1.86.12.57-.08 1.76-.72 2-1.42.25-.7.25-1.3.18-1.42-.07-.13-.27-.2-.57-.35z" />
        </svg>
      </span>
    </a>
  );
}

export { WHATSAPP_URL };
